export default "/images/6f989e84b717a1273488c3504a2673ce.avif";